import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { SHARE } from '../../config/text/text';
import { makeUrlAbsolute } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';

const MainDealNativeShare = ({ deal, className }) => {
  const theme = useContext(ThemeContext);

  const canShare = typeof navigator !== 'undefined' && navigator.share;
  if (!deal || !canShare) {
    return null;
  }

  const onNativeShare = async () => {
    try {
      await navigator.share({
        text: deal.title,
        title: deal.headline,
        url: makeUrlAbsolute(deal.shareUrl),
      });
    } catch {
      // no action, the button just won't work
    }
  };

  return (
    <>
      <button
        aria-label={SHARE}
        className={classNames('native-share', className)}
        onClick={onNativeShare}
        type="button"
      >
        <FontAwesomeIcon color={theme.colors.primary} icon={faShareAlt} />
      </button>

      <style jsx>{`
        .native-share {
          border: none;
          background-color: #aaaaaa;
          height: 30px;
          width: 30px;
          padding: 0;
          margin-bottom: 4px;
          border-radius: 4px;
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .native-share {
            height: 48px;
            width: 48px;
          }
          :global(.native-share svg) {
            transform: scale(1.5);
          }
        }
      `}</style>
    </>
  );
};

MainDealNativeShare.propTypes = {
  className: PropTypes.string,
  deal: PropTypes.object,
};

MainDealNativeShare.defaultProps = {
  className: '',
  deal: null,
};

export default MainDealNativeShare;
